import { Component, createRef } from 'react';
import { Popup } from 'devextreme-react';
import { EditNonMemberForm } from './edit-non-member-form';
import {
  CreateAuthorizedStore,
} from '~/helpers/data';
import { appConst } from '~/app-const';

const schoolsUrl = `${window.env.apiEndpoint}/api/v1/Schools`;

export class EditNonMemberPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popupTitle: 'Loading...',
    };

    this.provincesData = CreateAuthorizedStore({ loadUrl: `${schoolsUrl}/provincesLookup` }, null, 'Value');
    this.updateTitle = this.updateTitle.bind(this);

    this.editNonMemberFormRef = createRef();
    this.editNonMemberFormPopupRef = createRef();
  }

  updateTitle(newTitle) {
    this.setState({ popupTitle: newTitle || "Unable to show" });
  }

  renderNonMemberEditPopUp(isEditFormShown) {
    const {
      rowMemberData,
      nonMemberAddNewMode,
      hideNonMemberEditPopupAndRefreshGrid,
      hideNonMemberEditPopup,
    } = this.props;

    if (isEditFormShown) {
      const { showNonMemberEditForm, membersLookupData, selectedTabIndex } = this.props;
      return (
        <Popup
          ref={this.editNonMemberFormPopupRef}
          visible={showNonMemberEditForm}
          title={this.state.popupTitle}
          onHiding={(e) => {
            e.cancel = true;
            this?.editNonMemberFormRef?.current?.cancelData();
          }}
          {...appConst.defaultPopupOptions}
        >
          <EditNonMemberForm
            ref={this.editNonMemberFormRef}
            rowData={rowMemberData}
            hideEditPopupAndRefreshGrid={hideNonMemberEditPopupAndRefreshGrid}
            hideEditPopup={hideNonMemberEditPopup}
            salutationsData={membersLookupData.salutationsData}
            gendersData={membersLookupData.gendersData}
            pronounsData={membersLookupData.pronounsData}
            emailAddressTypesData={membersLookupData.emailAddressTypesData}
            phoneTypesData={membersLookupData.phoneTypesData}
            membershipTypesData={membersLookupData.membershipTypesData}
            employmentStatusesData={membersLookupData.employmentStatusesData}
            contractTypesData={membersLookupData.contractTypesData}
            designationsData={membersLookupData.designationsData}
            ridingsData={membersLookupData.ridingsData}
            addNewMode={nonMemberAddNewMode}
            provincesData={membersLookupData.provincesData}
            updateTitle={this.updateTitle}
            selectedTabIndex={selectedTabIndex}
          />
        </Popup>
      );
    }
  }

  render() {
    const { showNonMemberEditForm } = this.props;
    return (
      <>
        {this.renderNonMemberEditPopUp(showNonMemberEditForm)}
      </>
    );
  }
}
